import React from 'react';

import './style.scss';

const Radio = ({ onClick, checked, id, label, ...props }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick && onClick(e);
    }
  };

  return (
    <span
      className="radio__wrap"
      {...props}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="radio"
      aria-checked={checked}
      aria-label={label}
    >
      <input type="radio" checked={checked} id={id} aria-hidden="true" tabIndex={-1} />{' '}
      <span className="radio" aria-hidden="true">
        <span className="radio__inner"></span>
        <span className="radio__deco"></span>
      </span>
    </span>
  );
};

export default Radio;
